import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ToastMessage from "../Components/ToastMsgWrapper";

export const showToast = (message, type) => {
  if (!toast.isActive("toast-id")) {
    toast(<ToastMessage message={message} type={type} />, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      className: "custom-toast",
      toastId: "toast-id",
    });
  }
};
